<template>
    <div class="profile-list-with-carousel">
        <div class="title-con">
            <h3>{{ title }}</h3>
            <div class="controls-con" v-if="profiles.length > 5">
                <i class="icon icon-arrows-left"
                @click="slidePrev()"></i>
                <i class="icon icon-arrows-right"
                @click="slideNext()"></i>
            </div>
        </div>
    <swiper v-if="profiles.length > 5" ref="carousel" :options="swiper_options" @slideChange="slideChange"
            @click.native="sliderClicked">
            <swiper-slide v-for="profile in profiles" :key="profile.name" @click.native="clickedSlider">
                <profile-thumbnail :info="profile" ref="profile-thumb"></profile-thumbnail>
            </swiper-slide>
        </swiper>
        <div v-else class="row">
            <profile-thumbnail v-for="profile in profiles" :key="profile.name" :info="profile" ref="profile-thumb" class="col-10-2"></profile-thumbnail>
        </div>
    </div>
</template>

<script>
    import ProfileThumbnail from '@views/user/partials/ProfileThumbnail'
    import ProfileList from '@views/user/partials/ProfileListWithCarousel/profile_list'
    
    export default {
        name: 'profile-list-with-carousel',
        mixins: [ProfileList],
        components: {
            ProfileThumbnail
        }
    }
</script>

<style lang="scss" src="./profile_list.scss"></style>
